namespace RedBullMOBILE360.Sms {
    export class ExclusiveOffersColumns {
        static columnsKey = 'Sms.ExclusiveOffers';
    }
}